import { useSelector } from "react-redux/es/hooks/useSelector";
import HeaderImage from "./HeaderImage";
import NavBar from "./NavBar";
import TopBar from "./TopBar";
import "./style.scss";
import { useMediaQuery } from "react-responsive";
const HeaderWithNavbar = ({ setLocale, locale }) => {
  const generalDetails = useSelector(
    (state) => state.generalDetails.generalDetails
  );
  const isSmallScreen = useMediaQuery({ maxWidth: 991 });
  return (
    <header>
      {generalDetails.navigation_top
        ? !isSmallScreen && (
            <TopBar
              generalDetails={generalDetails}
              //setLocale={setLocale}
              //locale={locale}
            />
          )
        : ""}
      <HeaderImage />
      <NavBar generalDetails={generalDetails} />
    </header>
  );
};
export default HeaderWithNavbar;
